import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { modalButtonConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from './forms/form'
import ControlledInput from './inputs/controlled-input'
import ValidationButtons from './validation-buttons'

type Props = {
  defaultComment?: string
  className?: string
  onSuccess: (comment: string) => void | Promise<void>
  onCancel: () => void
}

type UpdateCommentInput = {
  comment: string
}

type CommentForm = Pick<UpdateCommentInput, 'comment'>

const schema = z.object({ comment: createStringSchema('Commentaire') })

const UpdateCommentForm = ({ defaultComment, className, onSuccess, onCancel }: Props) => {
  const [loading, setLoading] = useState(false)
  const form = useForm<CommentForm>({
    resolver: zodResolver(schema),
    mode: FORM_MODE,
    defaultValues: {
      comment: defaultComment || ''
    }
  })

  const onConfirm = async (data: CommentForm) => {
    setLoading(true)
    await onSuccess(data.comment)
    setLoading(false)
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onConfirm)}>
        <div className={className}>
          <FormField
            control={form.control}
            name="comment"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} type="textarea" label="Commentaire" />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <ValidationButtons
          hasBorderTop
          buttonsConfig={modalButtonConfig({
            isLoading: loading,
            onCancel,
            onConfirm
          })}
        />
      </form>
    </Form>
  )
}

export default UpdateCommentForm
